import { FaClinicMedical, FaBookMedical, FaTools, FaHospital, FaSitemap, FaUserMd } from 'react-icons/fa';
import ChainReport from "./ChainReport/ChainReport";
import ClinicReport from "./ClinicReport/ClinicReport";
import TreatmentsReport from './TreatmentsReport/TreatmentsReport';
import ErrorsReport from './ErrorsReport/ErrorsReport';
import StaffReport from './StaffReport/StaffReport';
import DistributorReport from './DistributorReport/DistributorReport';
import DistributorClinicsReport from './DistributorClinicsReport/DistributorClinicsReport';
import ApplicatorsReport from './ApplicatorsReport/ApplicatorsReport';
import api from 'helpers/api';
import { $t } from 'helpers/translator';

const chooseClinicField = {
    id: 'clinic_id',
    label: 'Choose Clinic',
    minUserRole: 3,
    type: 'select',
    options: 'clinics',
    placeholder: 'Choose Clinic',
    required: true
};

const chooseChainField = {
    id: 'clinic_id',
    label: 'Choose Chain',
    minUserRole: 4,
    type: 'select',
    options: 'chains',
    placeholder: 'Choose Chain',
    required: true
};

const ReportTypes = [
    {
        id: 'distributor_report',
        title: 'Distributor Report',
        description: "Create a report as a distributor. You can see the report of all the clinics in the chain.",
        icon: <FaSitemap />,
        minUserRole: 4,
        component: DistributorReport,
        fields: [
            {
                id: 'date_range',
                label: 'Date Range',
                type: 'date_range',
            },
        ]
    },
    {
        id: 'distributor_clinics_report',
        title: 'Distributor Clinics Report',
        description: "Create a report as a distributor. You can see the report of all the clinics in the chain.",
        icon: <FaSitemap />,
        userRole: 4,
        component: DistributorClinicsReport,
        fields: [
            {
                id: 'date_range',
                label: 'Date Range',
                type: 'date_range',
            },
        ]
    },
    {
        id: 'applicator_report',
        title: 'Applicators Report',
        description: "Create a report as a distributor. You can see the report of all the clinics in the chain.",
        icon: <FaSitemap />,
        userRole: 4,
        component: ApplicatorsReport,
        fields: [
            {
                id: 'date_range',
                label: 'Date Range',
                type: 'date_range',
            },
        ]
    },
    {
        id: 'chain_report',
        title: 'Chain Report',
        description: 'Create a report for your chain. Get summary data about all clinics in your chain.',
        icon: <FaHospital />,
        minUserRole: 3,
        component: ChainReport,
        fields: [
            {
                id: 'date_range',
                label: 'Date Range',
                type: 'date_range',
            },
            chooseChainField
        ]
    },
    {
        id: 'clinic_report',
        title: 'Clinic Report',
        description: 'Get overall summary data about your clinic. Get data about your clinic\'s treatments, errors and more.',
        icon: <FaClinicMedical />,
        minUserRole: 2,
        component: ClinicReport,
        fields: [
            {
                id: 'date_range',
                label: 'Date Range',
                type: 'date_range',
            },
            chooseClinicField
        ]
    },
    {
        id: 'treatment_report',
        title: 'Treatments Report',
        description: 'Create a report about your clinic\'s treatments. Shows data about overall trend, popular areas & skin types, etc..',
        icon: <FaBookMedical />,
        minUserRole: 2,
        component: TreatmentsReport,
        fields: [
            {
                id: 'date_range',
                label: 'Date Range',
                type: 'date_range',
            },
            chooseClinicField
        ]
    },
    {
        id: 'error_report',
        title: 'Errors Report',
        description: 'Create a report of your Alma equipment errors.',
        icon: <FaTools />,
        userRole: [2, 3],
        component: ErrorsReport,
        fields: [
            {
                id: 'date_range',
                label: 'Date Range',
                type: 'date_range',
            },
            chooseClinicField
        ]
    },
    {
        id: 'staff_report',
        title: 'Staff Report',
        description: 'Get an overview of your staff. Get data about your staff\'s treatments, working time and more.',
        icon: <FaUserMd />,
        userRole: [2, 3],
        component: StaffReport,
        fields: [
            {
                id: 'date_range',
                label: 'Date Range',
                type: 'date_range',
            },
            chooseClinicField
        ]
    }
]

export default ReportTypes